module.exports = __webpack_public_path__ + "static/media/portfolio7-4.7829440c.png";